/*
 * Copyright (c) 2025 curryfirm.com
 */

import * as constants from "../../constants.js";
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import fetchDumps from "./fetchDumps.js";


// Thunk to load dump locations from DumpsterTrack Sheets document.
export const fetchDumpsThunk = createAsyncThunk(
    'dumps/fetchDumps',
    async (_, thunkAPI) => {
        const { columnMap, rows } = await fetchDumps();
        if (!(columnMap && rows && rows.length > 0)) {
            throw new Error("Dumps worksheet did not load");
        }
        return rows.map(row => ({
            dumpName: row[columnMap[constants.DUMPS_COLUMN_TITLES.name]],
            lat: row[columnMap[constants.DUMPS_COLUMN_TITLES.lat]],
            lng: row[columnMap[constants.DUMPS_COLUMN_TITLES.lng]],
            street: row[columnMap[constants.DUMPS_COLUMN_TITLES.street]],
            city: row[columnMap[constants.DUMPS_COLUMN_TITLES.city]],
            state: row[columnMap[constants.DUMPS_COLUMN_TITLES.state]],
            zip: row[columnMap[constants.DUMPS_COLUMN_TITLES.zip]],
            locationId: row[columnMap[constants.DUMPS_COLUMN_TITLES.locationId]],
        }));
    }
);

const dumpsSlice = createSlice({
    name: 'dumps',
    initialState: {
        all: [], // Array of all dumpster objects
        loading: false,
        error: null,
    },
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchDumpsThunk.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchDumpsThunk.fulfilled, (state, action) => {
                state.loading = false;
                state.all = action.payload;
            })
            .addCase(fetchDumpsThunk.rejected, (state, action) => {
                state.loading = false;
                state.error =
                    action.payload?.message || // for thunks that use rejectWithValue
                    action.error?.message ||   // fallback for plain thrown errors
                    action.error ||            // fallback in case only a string is present
                    "Unknown error";
            });

    }
});

export const {
} = dumpsSlice.actions;

export default dumpsSlice.reducer;

// Selectors
export const selectAllDumps = state => state.dumps.all;
export const selectDumpsAreLoading = state => state.dumps.loading;
export const selectDumpsError = state => state.dumps.error;
